export default __webpack_public_path__ + "static/media/download.d76b31f6.svg";